module.exports = __webpack_public_path__ + "static/media/notfound.bd696362.svg";